module.exports = __webpack_public_path__ + "static/img/shuiyin.2c281df3.png";